import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';

export const ssoAuthGuard: CanActivateFn = async (route, state) => {
  // Bypass auth in local development if SSO is disabled
  if (!environment.enableSSO) {
    console.log('SSO DISABLED - Bypassing auth guard');
    localStorage.setItem('isLoading', 'false');
    return true;
  }

  const token = localStorage.getItem('access_token');
  const ssoUser = localStorage.getItem('uid');
  const expiresAt = localStorage.getItem('expires_at');
  const code = route.queryParams['code'];

  localStorage.setItem('isLoading', 'true');

  const authenticate: AuthService = inject(AuthService);

  
  if (token && expiresAt) {
    // get user details if not already fetched
    if (!ssoUser) {
      console.log('Fetch SSO User Details...');
      return await authenticate.validateToken('auth.guard.ts - Fetch SSO User Details...');
    }

    // Check if token is still valid
    const expiryDate = new Date(expiresAt);
    if (new Date() < expiryDate) {
      console.log('Token valid - AuthGuard - ', state.url);
      localStorage.setItem('isLoading', 'false');
      return true;
    } else {
      console.log('Token expired, redirecting to login');
      // Set the intended URL before logging out and logging in
      sessionStorage.setItem('redirectUrl', state.url);
      authenticate.logout();
      authenticate.login();
      return false;
    }
  } 
  // If we have an authorization code from SSO redirect
  else if (code) {
    return await authenticate.fetchToken(code);
  } 
  // No token and no code - redirect to login
  else {
    sessionStorage.setItem('redirectUrl', state.url);
    authenticate.login();
    return false;
  }
};